<template>
    <div class="package-card summary">
        <div class="summary-heading">Your Bundle</div>

        <template v-if="pkgTargetHours">
            <div class="tier-label">{{ pkgTargetHours }} Clock Hour Bundle</div>

            <package-progress class="mt-3"/>

            <div class="items mt-4">
                <div class="empty" v-if="pkgSelections.length === 0">No courses added yet.</div>
                <div class="item" v-for="selection in pkgSelections" :key="'cart-' + selection.key">
                    <div class="title-text">{{ selection.name }}</div>
                    <div class="hours">{{ selection.hours }} hrs</div>
                </div>
            </div>

            <div class="totals">
                <div class="row">
                    <div>À la carte value</div>
                    <div class="strike">{{ pkgAlacarte | money }}</div>
                </div>
                <div class="row">
                    <div>You save</div>
                    <div class="save">{{ pkgSavings | money }}</div>
                </div>
                <div class="row total">
                    <div>Total</div>
                    <div>{{ pkgPrice | money }}</div>
                </div>
                <div class="row tax" v-if="pkgTaxIncluded > 0">
                    <div>Includes sales tax</div>
                    <div>{{ pkgTaxIncluded | currency }}</div>
                </div>
            </div>

            <div class="pay-options" v-if="showPayOptions">
                <div class="options-heading">Pay Options</div>
                <div class="row" :class="{'is-chosen': pkgPay === 'full'}">
                    <div>Bundle cost</div>
                    <div class="value">{{ pkgUpfront | money }}</div>
                </div>
                <div class="row sub" :class="{'is-chosen': pkgPay === 'plan'}">
                    <div>or {{ pkgPlan.months }} payments of</div>
                    <div class="value">{{ pkgMonthly | money }}<span class="per">/mo</span></div>
                </div>
                <div class="row">
                    <div>Clock hour fees</div>
                    <div class="value">{{ pkgDeferred | money }}</div>
                </div>
            </div>
        </template>

        <div class="empty mt-2" v-else>
            Choose your hours to get started. Your selections and savings will appear here.
        </div>

        <slot/>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import PackageProgress from "./PackageProgress";

    export default {
        name: "PackageSummary",
        components: {PackageProgress},
        props: {
            // The review step drops the options block — choices are made
            showPayOptions: {type: Boolean, default: true}
        },
        computed: {
            ...mapGetters(['pkgTargetHours', 'pkgSelections', 'pkgAlacarte', 'pkgSavings', 'pkgPrice', 'pkgUpfront', 'pkgDeferred', 'pkgPay', 'pkgPlan', 'pkgMonthly', 'pkgTaxIncluded'])
        }
    };
</script>

<style lang="scss" scoped>
    .summary {
        .summary-heading {
            font-size: 0.75rem;
            font-weight: bold;
            letter-spacing: 0.06em;
            text-transform: uppercase;
            color: #7a8a9d;
        }

        .tier-label {
            font-size: 1.05rem;
            font-weight: 900;
            color: #33475b;
            margin-top: 0.4rem;
        }

        .empty {
            font-size: 0.85rem;
            color: #7a8a9d;
        }

        .items {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;

            .item {
                display: flex;
                justify-content: space-between;
                gap: 12px;
                font-size: 0.85rem;

                .title-text {
                    color: #33475b;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .hours {
                    color: #7a8a9d;
                    flex-shrink: 0;
                }
            }
        }

        .totals {
            border-top: 1px solid #eef1f5;
            margin-top: 1rem;
            padding-top: 0.9rem;
            display: flex;
            flex-direction: column;
            gap: 0.4rem;

            .row {
                display: flex;
                justify-content: space-between;
                font-size: 0.85rem;
                color: #666d7a;

                .strike {
                    color: #7a8a9d;
                    text-decoration: line-through;
                }

                .save {
                    font-weight: bold;
                    color: #2e7d4f;
                }

                &.total {
                    font-size: 1rem;
                    margin-top: 0.3rem;
                    font-weight: 900;
                    color: #33475b;

                    div:last-child {
                        color: #2e5f8f;
                    }
                }

                &.tax {
                    font-size: 0.75rem;
                    color: #7a8a9d;
                }
            }

        }

        .pay-options {
            border-top: 1px solid #eef1f5;
            margin-top: 0.9rem;
            padding-top: 0.8rem;
            display: flex;
            flex-direction: column;
            gap: 0.35rem;

            .options-heading {
                font-size: 0.7rem;
                font-weight: bold;
                letter-spacing: 0.06em;
                text-transform: uppercase;
                color: #7a8a9d;
                margin-bottom: 0.15rem;
            }

            .row {
                display: flex;
                justify-content: space-between;
                font-size: 0.85rem;
                color: #666d7a;
                border-radius: 4px;

                .value {
                    font-weight: bold;
                    color: #33475b;

                    .per {
                        font-weight: normal;
                        color: #7a8a9d;
                        font-size: 0.75rem;
                    }
                }

                &.sub {
                    font-size: 0.78rem;
                    color: #7a8a9d;
                }

                &.is-chosen {
                    background: #f2f7fc;
                    margin: 0 -0.5rem;
                    padding: 0.15rem 0.5rem;

                    .value {
                        color: #2e5f8f;
                    }
                }
            }
        }
    }
</style>
